import { render } from "./SummaryMetricChart.vue?vue&type=template&id=806e8d7c&scoped=true"
import script from "./SummaryMetricChart.vue?vue&type=script&setup=true&lang=js"
export * from "./SummaryMetricChart.vue?vue&type=script&setup=true&lang=js"

import "./SummaryMetricChart.vue?vue&type=style&index=0&id=806e8d7c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-806e8d7c"],['__file',"src/containers/components/metric/SummaryMetricChart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "806e8d7c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('806e8d7c', __exports__)) {
    api.reload('806e8d7c', __exports__)
  }
  
  module.hot.accept("./SummaryMetricChart.vue?vue&type=template&id=806e8d7c&scoped=true", () => {
    api.rerender('806e8d7c', render)
  })

}


export default __exports__